export default __webpack_public_path__ + "static/media/search.26017e15.svg";